import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
    selectedProduct: 0,
    notificationsStatus: "all",
    availableProducts: [],
    organization_status: [
        {name:"Active", value:1},
        {name:"Trial", value:2},
        {name:"Inactive", value:3},
        {name:"Warning", value:4},
    ],
    selectLeadList:[
        { name: 'outbound', value: '1' },
        { name: 'inbound', value: '2' },
    ],
    userRoles: {
        super_admin:0,
        admin: 1,
        crm: 2,
        editor: 3,
        support: 4,
        data_entry: 5,
        digital_marketing: 6,
        adh: 7,
        development_lead: 8,
        developer: 9,
        csm: 10,
        adh_helper: 11,
        qa:12,
    },
    getQa:[],
    org_users: [],
    userProducts: {},
    taskTypesList:[],
    teams:[],
}

// getters
const getters = {
    availableProducts: (state) => {
        return state.availableProducts;
    },
    organization_status: (state) => {
        return state.organization_status;
    },
    selectLeadList:(state) =>{
        return state.selectLeadList;
    },
    userRoles:(state) => {
        return state.userRoles;
    },
    getQa: (state) => {
        return state.getQa;
    },
    orgUsers: (state) => {
        return state.org_users;
    },
    selectedProduct: (state) => {
        return state.selectedProduct;
    },
    notificationsStatus: (state) => {
        return state.notificationsStatus;
    },
    userProducts: (state) => {
        return state.userProducts;
    },
    taskTypesList: (state) => {
        return state.taskTypesList;
    },
    teams: (state) => {
        return state.teams;
    },
}

// mutations
const mutations = {
    SET_AVAILABLE_PRODUCTS(state, availableProducts) {
        state.availableProducts = availableProducts;
    },
    SET_QA_USERS(state, getQa){
        state.getQa = getQa;
    },
    ORG_USERS: function (state, org_users) {
        state.org_users = org_users;
    },
    SET_PRODUCT(state, selectedProduct) {
        state.selectedProduct = selectedProduct;
    },
    SET_NOTIFICATIONS_STATUS(state, notificationsStatus) {
        state.notificationsStatus = notificationsStatus;
    },
    USER_PRODUCTS(state, userProducts){
        state.userProducts = userProducts;
    },
    SET_TYPES(state, taskTypesList) {
        state.taskTypesList = taskTypesList;
    },
    SET_TEAMS(state, teamsList) {
        state.teams = teamsList;
    },
}

// actions
const actions = {
    async setAvailableProducts({ commit }, availableProducts) {
        commit('SET_AVAILABLE_PRODUCTS',  availableProducts);
    },
    async SET_QA_USERS({ commit }, getQa) {
        commit('SET_QA_USERS',  getQa);
    },
    ORG_USERS: function ({ commit }, org_users) {
        commit('ORG_USERS',  org_users);
    },
    async setSelectedProduct({ commit }, product) {
        commit('SET_PRODUCT', product);
    },
    async setNotificationsStatus({ commit }, status) {
        commit('SET_NOTIFICATIONS_STATUS', status);
    },
    async setUserProducts({ commit }, products) {
        commit('USER_PRODUCTS', products);
    },
    async SET_TYPES({ commit }, taskTypesList) {
        commit('SET_TYPES', taskTypesList);
    },
    async SET_TEAMS({ commit }, teamsList) {
        commit('SET_TEAMS', teamsList);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
